export enum Guid {
  empty = '00000000-0000-0000-0000-000000000000',
  full = 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF',
}
